import { useTranslation } from '@mint-lib/i18n';
import styled from '@mint-lib/styled';
import { getRouteApi } from '@mint/routing';

import { Alert } from '@myn/mui';

import { RecoSettingsGoals } from '../../../../types/Recommendations.js';

export enum goalsType {
  CAMPAING = 'campaign',
  CHANNEL = 'channel',
  MEDIAROW = 'mediarow',
  ACQUISITIONS = 'goal-not-set-fallback-acquisitions',
}

type Map = {
  [key: string]: string;
};

const NAME_LINKS: Map = {
  campaign: 'Strategy - Campaign description',
  channel: 'Strategy - Channel mix',
  mediarow: 'Planning - Buying plan',
};

type Props = {
  goals: RecoSettingsGoals;
  onCloseModal: () => void;
  onWarningHide: () => void;
};

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

const PriorityChangeBlock = ({
  goals: { actual, expected },
  onCloseModal,
  onWarningHide,
}: Props) => {
  const { t } = useTranslation('@myn/planning');

  const params = routeApi.useParams();
  const navigate = routeApi.useNavigate();

  const getGoalName = (currentGoals: string) => {
    if (currentGoals === goalsType.MEDIAROW) {
      return 'media row';
    }
    return currentGoals === goalsType.ACQUISITIONS
      ? 'Acquisitions (default)'
      : currentGoals;
  };

  const handleLinkClick = () => {
    expected === goalsType.MEDIAROW
      ? onCloseModal()
      : navigate({
          to: '/campaign/$campaignId/strategy/campaign-description',
          params: { campaignId: params.campaignId },
        });
  };

  const handleBlockClose = () => {
    onWarningHide();
  };

  return (
    <Alert
      title={t('Information')}
      subTitle={t(
        `The {{actualGoal}} goal is used instead of the {{expectedGoal}} goal while generating suggestions. If you want the {{expectedGoal}} goal to be used, please check your settings.
Note that the changes will take some time to be applied.`,
        {
          actualGoal: getGoalName(actual),
          expectedGoal: getGoalName(expected),
        },
      )}
      severity="info"
      actions={
        <Link onClick={handleLinkClick}>
          {t(`Go to {{nameLink}}`, { nameLink: NAME_LINKS[expected] })}
        </Link>
      }
      removable
      onClose={handleBlockClose}
      sx={{ marginBottom: (theme) => theme.spacing(2) }}
    />
  );
};

export default PriorityChangeBlock;

const Link = styled('div')`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-top: ${({ theme }) => theme.spacing(1)};
  cursor: pointer;
`;
